import React, { FC } from 'react';
import ReactAnimateHeight from 'react-animate-height';

export interface AnimateHeightProps {
  show: boolean;
  duration?: number;
}

const AnimateHeight: FC<React.PropsWithChildren<AnimateHeightProps>> = (
  props
) => {
  const { show, duration = 300, children } = props;

  return (
    <ReactAnimateHeight
      data-style-for-print="accordion-data"
      duration={duration}
      height={show ? 'auto' : 1}
    >
      {children}
    </ReactAnimateHeight>
  );
};

export default AnimateHeight;
